var map = {
	"./facebook.png": 2510,
	"./instagram.png": 8673,
	"./line.png": 6364,
	"./linkedin.png": 7410,
	"./pinterest.png": 274,
	"./skype.png": 9890,
	"./telegram.png": 7433,
	"./twitter.png": 7248,
	"./wechat.png": 5356,
	"./whatsapp.png": 5139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 705;